import { useQuery } from '@tanstack/react-query';
import { MultiChannelOrderListRequest } from '../../../types/multiChannel/orderManagement';
import { MULTI_CHANNEL } from '../../../constants/queryKeys';
import multiChannelApi from '../../../lib/api/multiChannel/multiChannelApi';
import { MultiChannelOrderItemsFindResponseDto } from '../../../types/api/multi-channels';

type Options<T> = {
  select: (data: MultiChannelOrderItemsFindResponseDto) => T;
};
const useMultiChannelOrderList = <T = MultiChannelOrderItemsFindResponseDto>(
  payload: MultiChannelOrderListRequest,
  option?: Options<T>,
) => {
  return useQuery([...MULTI_CHANNEL.LIST, payload], () => multiChannelApi.getOrderList(payload), option);
};

export default useMultiChannelOrderList;
